import React from "react";

function Bannar() {
  return (
    <section className="hero-bannerr">
      <div className="hero-contentt">
        <div className="play">
          <span>Play</span>
        </div>
      </div>
    </section>
  );
}

export default Bannar;
